import React from 'react'
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import Main from './Main';
import Contact from './Contact';
import './App.css'

class App extends React.Component {

  render() {
    return (    
    <Router>
      <Switch>
        <Route exact path="/" component={Main}/>
        <Route path="/contacto" component={Contact}/>
        <Route component={Main}/>
      </Switch>    
      </Router>
    )
  }
}

export default App